const looksLikeJsonString = (value) => {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return trimmed.startsWith('{') || trimmed.startsWith('[');
};

/**
 * Returns true when the value is an object/array, or a string that parses
 * to an object or array. Primitive JSON values (true, 123, "hello") are not treated as JSON.
 */
export const isJsonValue = (value) => {
  if (value !== null && typeof value === 'object') return true;
  if (!looksLikeJsonString(value)) return false;

  try {
    const parsed = JSON.parse(value.trim());
    return parsed !== null && typeof parsed === 'object';
  } catch {
    return false;
  }
};

/**
 * Pretty-prints JSON object/array values. Non-JSON values are returned unchanged.
 * @returns {{ isJson: boolean, formatted: * }}
 */
export const formatJsonValue = (value) => {
  if (value !== null && typeof value === 'object') {
    return { isJson: true, formatted: JSON.stringify(value, null, 2) };
  }

  if (!looksLikeJsonString(value)) {
    return { isJson: false, formatted: value };
  }

  try {
    const parsed = JSON.parse(value.trim());
    if (parsed !== null && typeof parsed === 'object') {
      return { isJson: true, formatted: JSON.stringify(parsed, null, 2) };
    }
  } catch {
    // Fall through and return the original string.
  }

  return { isJson: false, formatted: value };
};

/**
 * Returns true when the current text looks like a JSON object or array
 * (starts with `{` or `[`) and should be validated before save.
 */
export const looksLikeJson = (value) => looksLikeJsonString(value);
